export default __webpack_public_path__ + "static/5-book-stack-1274d3bf533e852be741b0da6ba399d5.png";